import { createFileRoute, redirect } from "@tanstack/react-router";
import { getTokenByVivaCode } from "@/lib/orders.functions";

export const Route = createFileRoute("/payment/failure")({
  validateSearch: (search: Record<string, unknown>) => ({
    s: typeof search.s === "string" || typeof search.s === "number" ? String(search.s) : undefined,
  }),
  loaderDeps: ({ search }) => ({ s: search.s }),
  loader: async ({ deps }) => {
    if (deps.s) {
      const { token } = await getTokenByVivaCode({ data: { code: deps.s } });
      if (token) throw redirect({ to: "/order/$token", params: { token } });
    }
    throw redirect({ to: "/checkout" });
  },
});